// emailValidator.ts
import validator from "validator";

/**
 * Checks if an email is valid according to RFC standards,
 * supports all real TLDs, and rejects malformed emails.
 * @param email - The email string to validate
 * @returns boolean - true if valid, false otherwise
 */
export function isValidEmail(email){
  if (!email || typeof email !== "string") return false;

  // normalize and lowercase
  const sanitizedEmail = validator.normalizeEmail(email, { all_lowercase: true });
  if (!sanitizedEmail) return false;

  const [localPart, domain] = sanitizedEmail.split("@");

  // validate syntax, TLD, and length constraints
  if (
    !validator.isEmail(sanitizedEmail, { require_tld: true }) || // proper format + TLD
    !domain ||                                                 // domain must exist
    localPart.length > 64 ||                                   // local part max 64
    sanitizedEmail.length > 254                                // total max 254
  ) {
    return false;
  }

  return true;
}